import React from 'react';
import PropTypes from 'prop-types';

import JournalDatePicker from './JournalDatePicker';
import NavigationButton from './NavigationButton';

export default function NavigationControls({
  fetchDirection,
  isFetching,
  next,
  onJumpToDate,
  onNext,
  onPrev,
  prev,
}) {
  return (
    <div className="journal-entries__controls">
      {next && (
        <NavigationButton
          direction="next"
          fetchDirection={fetchDirection}
          isFetching={isFetching}
          onClick={onNext}
        />
      )}
      <JournalDatePicker
        onChange={onJumpToDate}
      />
      {prev && (
        <NavigationButton
          direction="prev"
          fetchDirection={fetchDirection}
          isFetching={isFetching}
          onClick={onPrev}
        />
      )}
    </div>
  );
}

NavigationControls.propTypes = {
  fetchDirection: PropTypes.oneOf(['next', 'prev']),
  isFetching: PropTypes.bool.isRequired,
  next: PropTypes.string,
  prev: PropTypes.string,
  onJumpToDate: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

NavigationControls.defaultProps = {
  fetchDirection: undefined,
  next: undefined,
  prev: undefined,
};